import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import WorkshopProduction from '@/roc/effects/Production/WorkshopProduction';
import {getIcon, WorkshopProductionGroup} from '@/roc/building/workshop/WorkshopOutput';
import EraType from '@/roc/era/EraType';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const StoneMason = {
  id: "13",
  name: "Stone Mason",
  width: 4,
  height: 3,
  type: BuildingType.WORKSHOP_1,
  era: "bronzeAge",
  icon: getIcon(WorkshopProductionGroup.StoneMason),
  minLevel: 1,
  maxLevel: BuildingMaxLevel.WORKSHOP_1,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Workshops/Stone_Mason',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: 1,
    minoanEra: 2,
    classicGreece: 3,
    earlyRome: 4,
    romanEmpire: 4,
    byzantineEra: 4,
    ageOfTheFranks: 4,
    feudalAge: 4,
    iberianEra: 4,
    kingdomOfSicily: 4,
    highMiddleAges: 4,
    earlyGothicEra: 4,
    lateGothicEra: 4,
  },
  effects: Effects.create([
    new WorkshopProduction(WorkshopProductionGroup.StoneMason, EraType.bronzeAge),
    new WorkshopProduction(WorkshopProductionGroup.StoneMason, EraType.minoanEra),
    new WorkshopProduction(WorkshopProductionGroup.StoneMason, EraType.classicGreece),
    new WorkshopProduction(WorkshopProductionGroup.StoneMason, EraType.earlyRome),
    new WorkshopProduction(WorkshopProductionGroup.StoneMason, EraType.romanEmpire),
    new Happiness({
      stoneAge: null,
      bronzeAge: [140, 270, 540],
      minoanEra: [180, 360, 720],
      classicGreece: [240, 480, 960],
      earlyRome: [300, 600, 1200],
      romanEmpire: [360, 720, 1440],
      byzantineEra: null,
      ageOfTheFranks: null,
      feudalAge: null,
      iberianEra: null,
      kingdomOfSicily: null,
      highMiddleAges: null,
      earlyGothicEra: null,
      lateGothicEra: null,
    }),
  ]),
};

export default StoneMason;
